import {
  sourcingEventsResponseSchema,
  type SourcingEventsResponse,
} from '../types';
import { ApiClientError } from '@/errors';
import {
  authFetch, API_BASE_URL 
} from '@/lib/api-client';

export async function getSourcingEvents(): Promise<SourcingEventsResponse> {
  const url = `${API_BASE_URL}/v1/sourcing-events`;
  const response = await authFetch(url);

  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch sourcing events');
  }

  return sourcingEventsResponseSchema.parse(await response.json());
}
